//@ts-nocheck

const normalizeDataObjByLang = (data) => {
  const serviceMenu = data.service?.length ? data.service.map(({ label, href, isAllSiteLink }) => ({
    cta: {
      label,
      href
    },
    isAllSiteLink
  })) : []

  let menu = []

  const headerMenu = data.main?.length ? data.main.map((item) => {
    if (!item) return 


    const withSubmenu = item.items
    const label = item.tagline || item.label
    const description = item.description
    const href = withSubmenu ? '#' : item.href
    const isPrimary = item.isPrimary

    if (withSubmenu) menu.push(item.items)

    return {
      label,
      description,
      href,
      withSubmenu,
      isPrimary
    }
  }): []

  return {
    serviceMenu,
    headerMenu,
    menu
  }
}

const Header = (data) => {
  if(!data) return {}

  const normalizedData = Object.keys(data).reduce((acc, item) => {
    return {
      ...acc,
      [item]: normalizeDataObjByLang(data[item])
    }
  }, {})

  return normalizedData
}

export default Header
